export enum VatType {
	FONTERRA = 'FonterraVatII',
	LONGVELD = 'Longveld',
	BUTTERFLY = 'Butterfly',
	SPHERICAL = 'Spherical',
	CROWN = 'Crown',
}

export interface VatAttributes {
	slopeOffset: number;
	diameter: number;
	radius: number;
	height: number;
	ventDistance: number;
}

// copied from the aws ingestion for milk
// todo this should be stored in the api so new vat models can be added to all places easily
export const VatModels: Map<string, Omit<VatAttributes, 'radius'> & { defaultOffset: number }> = new Map([
	[
		'FonterraVatII:2000',
		{ diameter: 1150, height: 2022, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:2300',
		{ diameter: 1650, height: 1099, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:3400',
		{ diameter: 1881, height: 1260, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:4100',
		{ diameter: 1881, height: 1493, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:4500',
		{ diameter: 2338, height: 1034, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:5700',
		{ diameter: 2338, height: 1338, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:6800',
		{ diameter: 2338, height: 1607, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:7800',
		{ diameter: 2338, height: 1817, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:9100',
		{ diameter: 2338, height: 2251, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:11000',
		{ diameter: 2338, height: 2562, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:11500W',
		{ diameter: 2875, height: 1794, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:12000',
		{ diameter: 2338, height: 2837, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:12000WMP',
		{ diameter: 2338, height: 3130, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:14000',
		{ diameter: 2338, height: 3312, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:14000W',
		{ diameter: 2875, height: 2232, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:15000',
		{ diameter: 2338, height: 3650, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:16000',
		{ diameter: 2338, height: 3750, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:16000W',
		{ diameter: 2875, height: 2518, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:18000',
		{ diameter: 2338, height: 4360, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:18000W',
		{ diameter: 2875, height: 2930, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:21500W',
		{ diameter: 2875, height: 3300, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:24500W',
		{ diameter: 2875, height: 3738, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:26500W',
		{ diameter: 2875, height: 4043, ventDistance: 830, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'FonterraVatII:30000W',
		{ diameter: 2875, height: 4823, ventDistance: 830, slopeOffset: 200, defaultOffset: 0 },
	],

	[
		'Longveld:5400',
		{ diameter: 2338, height: 1500, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],
	[
		'Longveld:7500',
		{ diameter: 2338, height: 2000, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],
	[
		'Longveld:9400',
		{ diameter: 2338, height: 2440, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],
	[
		'Longveld:11400',
		{ diameter: 2900, height: 2100, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],
	[
		'Longveld:21000',
		{ diameter: 2900, height: 3520, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],
	[
		'Longveld:29000',
		{ diameter: 2900, height: 4628, ventDistance: 830, slopeOffset: 257, defaultOffset: 0 },
	],

	[
		'Butterfly:1050',
		{ diameter: 1645, height: 610, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:1700',
		{ diameter: 1645, height: 915, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:2250',
		{ diameter: 1645, height: 1175, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:2700',
		{ diameter: 1645, height: 1420, ventDistance: 310, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'Butterfly:2700Cummings',
		{ diameter: 1645, height: 1420, ventDistance: 310, slopeOffset: 200, defaultOffset: 250 },
	],
	[
		'Butterfly:3400',
		{ diameter: 1885, height: 1465, ventDistance: 235, slopeOffset: 245, defaultOffset: 250 },
	],
	[
		'Butterfly:3400Winiata',
		{ diameter: 1885, height: 1465, ventDistance: 235, slopeOffset: 245, defaultOffset: 250 },
	],
	[
		'Butterfly:3400KMOrganics',
		{ diameter: 1860, height: 1465, ventDistance: 230, slopeOffset: 245, defaultOffset: 250 },
	],
	[
		'Butterfly:3700',
		{ diameter: 1880, height: 1465, ventDistance: 720, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:3700DargavilleOrganics',
		{ diameter: 1880, height: 1465, ventDistance: 720, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:4100',
		{ diameter: 1880, height: 1595, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:4500',
		{ diameter: 1880, height: 1760, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:4500TawaRidge',
		{ diameter: 1880, height: 1760, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:4710MJDFarms',
		{ diameter: 2150, height: 1300, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:5700',
		{ diameter: 1880, height: 2170, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:6800',
		{ diameter: 1880, height: 2565, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],
	[
		'Butterfly:9100',
		{ diameter: 1880, height: 3395, ventDistance: 235, slopeOffset: 230, defaultOffset: 250 },
	],

	[
		'Spherical:10000',
		{ diameter: 2673, height: 2673, ventDistance: 0, slopeOffset: 0, defaultOffset: 0 },
	],
	[
		'Spherical:14000',
		{ diameter: 2990, height: 2990, ventDistance: 0, slopeOffset: 0, defaultOffset: 0 },
	],
	[
		'Spherical:24500',
		{ diameter: 3600, height: 3600, ventDistance: 0, slopeOffset: 0, defaultOffset: 0 },
	],
	[
		'Spherical:31000',
		{ diameter: 3900, height: 3900, ventDistance: 0, slopeOffset: 0, defaultOffset: 0 },
	],

	['Crown:22000W', { diameter: 0, height: 0, ventDistance: 0, slopeOffset: 0, defaultOffset: 0 }],
]);
